module.exports = __webpack_public_path__ + "img/z (23).fda625ce.png";